<template>

    <form ref="empresaparceira-form-edit" v-on:submit.prevent="executeEdit(model)" novalidate>

        <div class="row">


            <div class="form-group col-md-6">
                <label for="Nome">Nome</label>
                <input type="text" class="form-control" name="pessoaEscola.nome" placeholder="Nome" v-model="model.empresa.pessoaEscola.nome" maxlength="100" required />
            </div>
            <div class="form-group col-md-6">
                <label for="RazaoSocial">Razão Social</label>
                <input type="text" class="form-control" name="RazaoSocial" placeholder="Razão Social" v-model="model.empresa.pessoaEscola.apelido" maxlength="100" required />
            </div>
            <div class="form-group col-md-6">
                <label for="cNPJ">CNPJ</label>
                <input type="text" class="form-control" name="cNPJ" placeholder="CNPJ" v-mask="mask_cnpj" v-model="model.empresa.pessoaEscola.cpF_CNPJ" maxlength="18" required />
            </div>
            <div class="form-group col-md-6">
                <label for="iE">IE</label>
                <input type="text" class="form-control" name="iE" placeholder="IE" v-model="model.empresa.pessoaEscola.rG_IE" maxlength="50"/>
            </div>
            <div class="form-group col-md-6">
                <label for="contato">Responsável para Contato</label>
                <input type="text" class="form-control" name="contato" placeholder="Responsável para Contato" v-model="model.contato" required  maxlength="150"/>
            </div>
            <div class="form-group col-md-6">
                <label for="tipo">Tipo</label>
                <div class="form-group">
                    <label class="custom-control custom-radio custom-control-inline">
                        <input type="radio" name="tipo" v-model="model.tipoParceriaId" value="1" required class="custom-control-input">
                        <span class="custom-control-indicator"></span>
                        <span class="custom-control-description">Nacional</span>
                    </label>
                    <label class="custom-control custom-radio custom-control-inline">
                        <input type="radio" name="tipo" v-model="model.tipoParceriaId" value="2" required class="custom-control-input">
                        <span class="custom-control-indicator"></span>
                        <span class="custom-control-description">Regional</span>
                    </label>
                    <label class="custom-control custom-radio custom-control-inline">
                        <input type="radio" name="tipo" v-model="model.tipoParceriaId" value="3" required class="custom-control-input">
                        <span class="custom-control-indicator"></span>
                        <span class="custom-control-description">Estadual</span>
                    </label>
                </div>
            </div>
            <div class="form-group col-md-6">
                <label for="categoriaEmpresaParceiraId">Categoria</label>
                <select required v-select="{ dataitem: 'CategoriaEmpresaParceira', default: 'Selecione' }" v-model="model.categoriaEmpresaParceiraId" class="form-control" name="categoriaEmpresaParceiraId"></select>
            </div>
            <div class="form-group col-md-6">
                <label for="quantidadeFuncionarios">Quantidade de Funcionários</label>
                <input type="number" class="form-control" name="quantidadeFuncionarios" placeholder="Quantidade de Funcionários" v-model="model.quantidadeFuncionarios" />
            </div>
            <div class="form-group col-md-6">
                <label for="cEP">CEP</label>
                <input type="text" class="form-control" name="cEP" placeholder="CEP" v-model="model.empresa.pessoaEscola.endereco.cEP" maxlength="9" />
            </div>
            <div class="form-group col-md-6">
                <label for="rua">Rua</label>
                <input type="text" class="form-control" name="rua" placeholder="Rua" v-model="model.empresa.pessoaEscola.endereco.rua" required  maxlength="150"/>
            </div>
            <div class="form-group col-md-6">
                <label for="numero">Número</label>
                <input type="number" class="form-control" name="numero" placeholder="Número" v-model="model.empresa.pessoaEscola.endereco.numero" required />
            </div>
            <div class="form-group col-md-6">
                <label for="complemento">Complemento</label>
                <input type="text" class="form-control" name="complemento" placeholder="Complemento" v-model="model.empresa.pessoaEscola.endereco.complemento"  maxlength="150" />
            </div>
            <div class="form-group col-md-6">
                <label for="pontoReferencia">Ponto de Referência</label>
                <input type="text" class="form-control" name="rua" placeholder="Ponto de Referência" v-model="model.empresa.pessoaEscola.endereco.pontoReferencia" maxlength="200"/>
            </div>
            <div class="form-group col-md-6">
                <label for="cidade">Cidade</label>
                <input required type="text" class="form-control" name="cidade" placeholder="Cidade" v-model="model.empresa.pessoaEscola.endereco.cidade" maxlength="200"/>
            </div>
            <div class="form-group col-md-6">
                <label for="rua">Estado</label>
                <select v-select="{ dataitem: 'Estado', default: 'Selecione' }" v-model="model.empresa.pessoaEscola.endereco.estadoId" class="form-control" name="estadoId" required></select>
            </div>
            <div class="form-group col-md-6">
                <label for="bairro">Bairro</label>
                <input type="text" class="form-control" name="rua" placeholder="Bairro" v-model="model.empresa.pessoaEscola.endereco.bairro" required  maxlength="100"/>
            </div>


        </div>

        <button type="button" class="btn btn-default" @click="onBack()">
            <span>Voltar</span>
        </button>
        <button type="button" class="btn btn-success float-right" @click="executeEdit(model)">
            <span>Salvar</span>
        </button>

    </form>


</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: "empresaparceira-form-edit",
        mixins: [base],
        props: { id: Number },
        data: () => ({

            model:
            {
                categoriaEmpresaParceiraId: "",
                empresa:
                {
                    pessoaEscola:
                    {
                        endereco:
                        {
                            estadoId: ""
                        }
                    }
                }
            },

            form: "empresaparceira-form-edit",

            resources: {
                edit: 'empresaparceira',
            },

        }),

        methods: {

            executeEdit: function (model) {
                if (this.formValidate() == false) return;
                
                new Api(this.resources.edit).put(model).then(data => {
                    this.defaultSuccessResult("Edição realizada com sucesso");
                    this.$emit('on-saved', data)
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            formValidate: function () {
                var $form = this.$refs[this.form];
                $form.classList.add("was-validated");
                return $form.checkValidity();
            },

            onBack: function () {
                this.$emit('on-back')
            }
        },

        mounted() {
            new Api(this.resources.edit).get({ empresaParceiraId: this.id }).then(data => {
                if (data.data) this.model = data.data;
                else if (!data.dataList) this.model = {};
                else if (data.dataList.length == 1) this.model = data.dataList[0];
                else this.model = {};
            }, err => {
                this.defaultErrorResult(err);
            })
        }
    };
</script>